/**!*******************************************************************
 *
 * Copyright (c) ChatCaptain GmbH. All rights reserved.
 * Author:  Alexander Claas
 *
 ********************************************************************!*/

import { defineComponent } from "vue";
import { IMdOverlay } from ".";

export default defineComponent({
  emits: ["cancel", "submit"],
  props: {
    loading: Boolean,
  },
  methods: {
    open() {
      (this.$refs.overlay as IMdOverlay).open();
    },
    close() {
      (this.$refs.overlay as IMdOverlay).close();
    },
    /**
     *
     * @param state true = display the loader, false = no loader
     */
    setLoading(state: boolean) {
      (this.$refs.overlay as IMdOverlay).setLoading(state);
    },
  },
});
